/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsDraftRankCostEntryDtoSchema = z.object({
  tier: z.string().nullish(),
  division: z.string().nullish(),
  lpFrom: z.int().nullish(),
  value: z.optional(z.int()),
});
